import React from "react";
import learningPortal from "../../assets/image/learningportal.svg";
import LoginForm from "../../components/auth/LoginForm";
import { Link } from "react-router-dom";
function StudentLogin() {
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={learningPortal} alt="brand" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Sign in to Student Account
          </h2>
        </div>
        <LoginForm />
        <div className="flex items-center my-3">
          <div className="text-sm">
            <span className="font-medium text-violet-600 hover:text-violet-500">
              Don't have an account?
            </span>
          </div>
        </div>
        <div>
          <Link to="/register">
            <button className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan hover:bg-cyan focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
              Sign Up
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default StudentLogin;
